module.exports = __webpack_public_path__ + "img/cooking-food.3b38e3a8.jpg";